<template>
  <div
    class="ys-float-btn"
    :style="{'width': `${itemWidth}px`,'height': `${itemHeight}px`,'left': `${left}px`,'top': `${top}px`}"
    ref="div"
    @click="onBtnClicked"
  >
    <slot name="icon"></slot>
    <!-- <van-image class="su_img" :src="require('@/assets/images/index/panoramicView.png')" fit="cover"></van-image> -->
  </div>
</template>

<script>
export default {
  name: 'FloatImgBtn',
  props: {
    itemWidth: {
      type: Number,
      default: 60
    },
    itemHeight: {
      type: Number,
      default: 60
    },
    gapWidth: {
      type: Number,
      default: 55
    },
    coefficientHeight: {
      type: Number,
      default: 0.3
    }
  },
  data () {
    return {
      timer: null,
      currentTop: 0,
      clientWidth: 0,
      clientHeight: 0,
      left: 0,
      top: 0
    }
  },
  created () {
    this.setPosition()
  },
  mounted () {
    this.setTouch()
  },
  methods: {
    setPosition () {
      this.clientWidth = document.documentElement.clientWidth
      this.clientHeight = document.documentElement.clientHeight
      this.left = this.clientWidth - this.itemWidth - this.gapWidth
      this.top = this.clientHeight * this.coefficientHeight
    },
    setTouch () {
      this.$nextTick(() => {
        const div = this.$refs.div
        div.addEventListener('touchstart', (e) => {
          div.style.transition = 'none'
        })
        div.addEventListener('touchmove', (e) => {
          // e.preventDefault()
          if (e.targetTouches.length === 1) {
            const touch = event.targetTouches[0]
            this.left = touch.clientX - this.itemWidth / 2
            this.top = touch.clientY - this.itemHeight / 2
          }
        },
        false
        )
        div.addEventListener('touchend', (e) => {
          // e.stopPropagation()
          // e.preventDefault()
          div.style.transition = 'all 0.3s'
          // if (this.left > this.clientWidth / 2) {
          this.left = this.left < 100000 ? this.clientWidth - this.itemWidth - this.gapWidth : this.gapWidth
          if (this.top <= 36) {
            this.top = 36 + this.gapWidth
          } else {
            const bottom = this.clientHeight - 50 - this.itemHeight - this.gapWidth
            // console.log(bottom, this.top)
            if (this.top >= bottom) this.top = bottom
          }
        })
      })
    },
    onBtnClicked () {
      this.$emit('onFloatBtnClicked')
    }
  }
}
</script>

<style lang="scss" scoped>
.ys-float-btn{
  // box-shadow:0 2px 10px 0 rgba(0,0,0,0.1);
  color: #666;
  z-index: 2000;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  // bottom: 20vw;
  // img{
  //   width: 50%;
  //   height: 50%;
  //   object-fit: contain;
  //   margin-bottom: 3px;
  // }
}
</style>
